import {Section} from "../components/Section";
import {LanguageSelector} from "../components/LanguageSelector";
import {Header} from "../components/Header";
import {HeroSection} from "../components/HeroSection";
import {Footer} from "../components/Footer";
import React from "react";
import {useLanguage} from "../context/LanguageContext";
import {translations} from "../utils/translations";

export function PrivacyPolicyPage() {
   const PrivacyComponent = ({t}: any) => {
       return (
           <Section>
               <h1>{t.privacy.title}</h1>
               <p>{t.privacy.description}</p>
           </Section>
       )
   }
    const {lang} = useLanguage();
    const t = translations[lang];

    return (
        <main className="static-page">
            <LanguageSelector/>
            <Header t={t} isBackButtonVisible={true}/>
            <HeroSection t={t}/>
            <PrivacyComponent t={t}/>
            <Footer t={t}/>
        </main>
    );
}